import { render } from "./InteractiveDiscussion.vue?vue&type=template&id=1e63bf6d"
import script from "./InteractiveDiscussion.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./InteractiveDiscussion.vue?vue&type=script&charset=utf-8&lang=js"

import "./InteractiveDiscussion.vue?vue&type=style&index=0&id=1e63bf6d&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__